window.MiddlewareApi = {
    call: async function ({path, params}) {
        let apiUrl = window.SSO_MIDDLEWARE_API_URL || 'https://middleware.icuracao.com/api/v1';
        apiUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;

        const response = await fetch(
            apiUrl + path,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Store-Code': 'tires'
                },
                body: JSON.stringify(params),
                redirect: "follow"
            }
        );

        return await response.json();
    }
};

window.MultipassToken = {
    apply: function (token) {
        location.pathname = `/account/login/multipass/${token}`;
    }
};

const ClientSession = {
    getParsed: function (name) {
        try {
            const value = this.get(name);
            return JSON.parse(value);
        } catch (error) {
            return null;
        }
    },

    get: function (name) {
        return localStorage.getItem(name);
    },

    delete: function (name) {
        localStorage.removeItem(name);
    },

    set: function (name, value) {
        localStorage.setItem(name, value);
    }
};

window.PostLoginHandler = {
    _key: 'ARgsBzoWAQAQAAcKHgQXABAXBhYAGisCBBUe',

    get: function () {
        return ClientSession.get(this._key);
    },

    remember: function (signature) {
        ClientSession.set(this._key, signature);
    },

    clear: function () {
        ClientSession.delete(this._key);
    }
};

window.PostChangingPasswordHandler = {
    _key: 'ARgsBzoAGgQaOA4BJh0YLAASDAAB',

    get: function () {
        return ClientSession.get(this._key);
    },

    remember: function (signature) {
        ClientSession.set(this._key, signature);
    },

    clear: function () {
        ClientSession.delete(this._key);
    }
};

window.CustomerSyncHandler = {
    _key: 'B0cYEF9fB0cYEF9fVh5vF0sFBw==',

    isSynced: function () {
        const value = ClientSession.get(this._key);
        return value === 'true' || value === '1';
    },

    markAsSynced: function () {
        ClientSession.set(this._key, true);
    },

    clear: function () {
        ClientSession.delete(this._key);
    }
};

window.FieldValidator = {
    isValidPhoneNumber: function (phone) {
        const regex = /^\+?\s*(1-?)?\s*(\([2-9]\s*\d{2}\s*\)|[2-9]\s*\d{2}\s*)\s*-?[2-9]\s*\d{2}\s*-?\d{4}$/;
        return regex.test(phone);
    },

    isValidEmail: function (email) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    }
};
